'use client'

import type { ReactNode } from 'react'

import { Button, Icon } from '@graftcode/design-system'

import { Logo } from '../../../Logo'
import { useMobileMenuContext } from '../../context'

import styles from '../../MobileMenu.module.scss'

interface MobileMenuHeaderProps {
  showSearch?: boolean
  showFeedback?: boolean
  showNotifications?: boolean
  notificationBadge?: number
  additionalActions?: ReactNode
  isScrolled?: boolean
  onFeedbackClick?: () => void
  onNotificationClick?: () => void
}

export function MobileMenuHeader({
  showSearch = true,
  showFeedback = true,
  showNotifications = true,
  notificationBadge,
  additionalActions,
  isScrolled = false,
  onFeedbackClick,
  onNotificationClick,
}: MobileMenuHeaderProps) {
  const { onClose } = useMobileMenuContext()

  return (
    <div className={`${styles.header} ${isScrolled ? styles.headerScrolled : ''}`}>
      <div className={styles.headerLogo}>
        <Logo />
      </div>

      <div className={styles.headerActions}>
        {showSearch && (
          <Button iconOnly size="l" variant="ghost" icon={Icon.SearchRegular} disabled className={styles.search} />
        )}
        {showFeedback && (
          <Button
            iconOnly
            size="l"
            variant="ghost"
            icon={Icon.QuestionCircleRegular}
            disabled={!onFeedbackClick}
            onClick={onFeedbackClick}
            className={styles.feedback}
          />
        )}
        {showNotifications && (
          <div className={styles.notificationBtn}>
            <Button
              iconOnly
              size="l"
              variant="ghost"
              icon={Icon.AlertRegular}
              disabled={!onNotificationClick}
              onClick={onNotificationClick}
              className={styles.notification}
            />
            {!!notificationBadge && notificationBadge > 0 ? (
              <span className={styles.notificationBadge} aria-hidden="true">
                {notificationBadge}
              </span>
            ) : null}
          </div>
        )}
        {additionalActions}
        <Button iconOnly size="l" variant="ghost" icon={Icon.DismissRegular} onClick={onClose} />
      </div>
    </div>
  )
}
